module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAVBJREFUWEftl01KBEEMRt+HoOhmFBH1Eh5glrrwDC5EQccjeAiP4CC6EPEKwqxm4QU8hD8o6kZUkEgJgtNDGYLd0Ehlm3Ty+JKuSomWmlrKRQGLdqYoVqtiZjYLHAKrwEQ0uRP/AQyBnqSHauyvrTSzE2CrZqBqunNJG1GwG2CxYbB7SQtRsEcgtbNJe5I0V8ACEhfFAmJ9hRbFimLlHPs5A95d2dqT/wiYiU5zMP5F0k70SupA4+u3SXqOgrW2lXfA2EoSbJUXfitpKarYGTC2xHmVgv5TSZtRsHmgD6wBk5mC6c+eyvjeAMv43oEBsCspjcyI/fmVZGapDdeZ4suS0hYctgIWlSykmJmtAAeVmUqz180UvgTSLH3bK7Av6coDjYKlN2bPS+r4+5L2vBxRsHXgGJj2Emf8SbFtSRfe9yEwL1md/gIWVbMo9m8U+wTb/own+dG+/QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_about_platform01.png
// module id = Omds
// module chunks = 1